
import { STATUS } from "../../components/pages/Widget/constants";
import { actionTypes } from "../_actions/widget.action";

export interface WidgetState {
  orderId: number | null;
  orderStatus: STATUS;
}

const initialState: WidgetState = {
  orderId: null,
  orderStatus: STATUS.prepare,
};
const widget = (state = initialState, action): WidgetState => {
  switch (action.type) {
    case actionTypes.SAVE_ORDER_ID:
      return {
        ...state,
        orderId: action.data,
      };
    case actionTypes.SAVE_ORDER_STATUS:
      return {
        ...state,
        orderStatus: action.data,
      };
    case actionTypes.RESET_ORDER_STATUS:
      return initialState;
    default:
      return state;
  }
};

export default widget;
